import React from 'react';
import Aux from '../../../../hoc/_Aux';

const DoubleZigzag = (props) => {

    let shape1Style = {};
    let shape2Style = {};
    let globalSVGStyle = {};
    if(typeof props.color1 !=='undefined'){
        shape1Style.fill = props.color1;
    }
    if(typeof props.color2 !=='undefined'){
        shape2Style.fill = props.color2 ;
    }
    
    if(typeof props.rotateAngle!== 'undefined'){
        globalSVGStyle.transform = 'rotate('+props.rotateAngle+'deg)';
    }

    return(
        <Aux>
            <svg id="double-zigzag-shape" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 58 47" style={globalSVGStyle}>
            <g>
                <path style={shape1Style} className="shape-color1" d="M16.83,15.429,9.23,7.822,3.46,13.6-.014,10.12,9.24.749l7.6,7.715,7.295-7.3L31.3,8.335,39.683-.056,46.522,6.9l5.553-5.558,3.474,3.477-9.036,9.045-6.84-6.846-8.383,8.391L24.124,8.236Z" transform="translate(2.168 4.35)"/>
                <path style={shape2Style} className="shape-color2" d="M16.83,15.429,9.23,7.822,3.46,13.6-.014,10.12,9.24.749l7.6,7.715,7.295-7.3L31.3,8.335,39.683-.056,46.522,6.9l5.553-5.558,3.474,3.477-9.036,9.045-6.84-6.846-8.383,8.391L24.124,8.236Z"/>
            </g>
            </svg>

        </Aux>
    );
}

export default DoubleZigzag;


// WEBPACK FOOTER //
// ./src/containers/UI/Common/Shapes/DoubleZigzag.js